/* eslint-disable */
import {axios} from "~/plugins/axios";
import moment from "moment";

const getDefaultState_GraphQl = () => {
  return {
    dashboards: [],
    dashboard: {},
    editedWidgetId: '',
  }
}
const state = getDefaultState_GraphQl();

const getters = {
  dashboards: state => state.dashboards,
  dashboard: state => state.dashboard,
  editedWidgetId: state => state.editedWidgetId,
}

const actions = {
  async loadDashboards({ commit, dispatch }) {
    let boards = await axios.get('/api/dashboards')
      .then(res => {
        return res.data.map(item => item.id)
      })
      .catch(error => {
        console.error(error);
      })

    let dashboards = [];

    // migration cause
    let oldDashboard = false;
    if (boards.length === 1) {
      await axios.get(`/api/dashboards/${boards[0]}`)
      .then(res => {
        let content = res?.data?.content;
        
        if (content) {
          let dashboard = JSON.parse(content);
          if (typeof dashboard === 'string') dashboard = JSON.parse(dashboard);
          if (!Array.isArray(dashboard)) return
          oldDashboard = true;

          dashboards.push({
            id: boards[0],
            name: 'temp',
            title: 'temp',
            tab_order: 0,
            widgets: dashboard
          });
          commit('SET_DASHBOARD', dashboards[0]);
          dispatch('saveDashboard');
        }
      })
    }

    if (!oldDashboard) {
      for (let id of boards) {
        await axios.get(`/api/dashboards/${id}`)
        .then(res => {
          let content = res?.data?.content;
          if (content) {
            let dashboard = JSON.parse(content);
            dashboard.id = id;
            dashboards.push(dashboard);
          }
        })
      }
    }

    commit('SET_DASHBOARDS', dashboards);
  },

  async saveDashboard({ state, commit }) {
    await axios.put(`/api/dashboards/${state.dashboard.id}`, {
      content: JSON.stringify(state.dashboard),
      is_private: true,
    })
      .catch((error) => {
        commit('shared/SET_ERROR', error.response.data, {root: true});
      })
  },

  async createDashboard({ dispatch }, payload) {
    await axios.post('/api/dashboards', payload);

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 220);

    await dispatch('loadDashboards');
  },

  async deleteDashboard({ state, commit, dispatch }) {
    if (state.dashboards.length === 1) {
      commit('shared/SET_SUCCESS', {message: 'Нельзя удалить последний дашборд'}, {root: true});
      return
    }
    await axios.delete(`/api/dashboards/${state.dashboard.id}`)
      .then((response) => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true});
      })
      .catch((error) => {
        commit('shared/SET_ERROR', error.response.data, {root: true});
      })

    dispatch('loadDashboards');
  },

  async shareDashboards({ commit }, payload) {
    await axios.get(`/api/dashboards/${payload.dashboard_id}/share/${payload.user_id}`)
      .then((response) => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true});
      })
      .catch((error) => {
        commit('shared/SET_ERROR', error.response.data, {root: true});
      })
  },

  setDashboard({ commit }, payload) {
    commit('SET_DASHBOARD', payload);
  },

  async loadEmploymentWidget(context, payload) {
    let newPaload = {};
    newPaload.groups = payload.groups;
    newPaload.period = getPeriod(payload.period);

    let res = await axios.post('/api/dashboards/widgets/employment/report', newPaload)
      .then(res => res.data)
      .catch(error => {
        console.error(error);
      })

    return res
  },

  async loadTableSlWidget(context, payload) {
    let newPaload = {};
    newPaload.period = getPeriod(payload.period);
    newPaload.projects = payload.projectsSingle
    let res = await axios.post('/api/dashboards/widgets/table_sl/report', newPaload)
      .then(res => res.data)
      .catch(error => {
        console.error(error);
      })

    return res
  },

  async loadAcceptedMissedWidget(context, payload) {
    let newPayload = {};
    newPayload.period = getPeriod(payload.period);
    if (!payload.isAllProjects) newPayload.projects = payload.projects;

    let res = await axios.post('/api/dashboards/widgets/accepted_to_missed_calls/report', newPayload)
      .then(res => res.data)
      .catch(error => {
        console.error(error);
      })

    return res
  },

  async loadGroupByOperatorWidget(context, payload) {
    let newPayload = {};
    newPayload.period = getPeriod(payload.period);
    if (!payload.isAllProjects) newPayload.projects = payload.projects;

    let res = await axios.post('/api/dashboards/widgets/group_by_operators/report', newPayload)
      .then(res => res.data)
      .catch(error => {
        console.error(error);
      })

    return res
  },

  async loadStatisticByOperatorWidget(context, payload) {
    let newPayload = {};
    newPayload.period = getPeriod(payload.period);
    if (!payload.isAllProjects) newPayload.projects = payload.projects;

    let res = await axios.post('/api/dashboards/widgets/statistic-by-operators/report', newPayload)
      .then(res => res.data)
      .catch(error => {
        console.error(error);
      })

    return res
  },

  async loadExtendedCallWidget(context, payload) {
    let newPayload = {};
    newPayload.period = getPeriod(payload.period);
    if (!payload.isAllProjects) newPayload.projects = payload.projects;
    newPayload.type = payload.type;

    let res = await axios.post('/api/dashboards/widgets/extended_information/report', newPayload)
      .then(res => res.data)
      .catch(error => {
        console.warn(error);
        return false
      })

    return res
  },

  async loadOksReportWidget(context, payload) {
    let newPayload = {};
    newPayload.period = getPeriod(payload.period);
    if (!payload.isAllProjects) newPayload.projects = payload.projects;
    newPayload.type = payload.type;
    newPayload.only_low_sla = payload.only_low_sla;

    let res = await axios.post('/api/dashboards/widgets/oks_report/report', newPayload)
      .then(res => res.data)
      .catch(error => {
        console.error(error);
      })

    return res
  },

  async loadAvgAgentTimeWidget(context, payload) {
    let newPayload = {};
    newPayload.period = getPeriod(payload.period);
    if (!payload.isAllProjects) newPayload.projects = payload.projects;

    let res = await axios.post('/api/dashboards/widgets/avg_agent_time/report', newPayload)
      .then(res => res.data)
      .catch(error => {
        console.error(error);
      })

    return res
  },

  async loadForecastCallsWidget(context, payload) {
    let newPayload = {};
    newPayload.period = getPeriod('currMonth');
    if (!payload.isAllProjects) newPayload.projects = payload.projects;

    let res = await axios.post('/api/dashboards/widgets/forecastmin/report', newPayload)
      .then(res => res.data)
      .catch(error => {
        console.error(error);
      })

    return res
  },

  async loadTransferWidget(context, payload) {
    let newPayload = {};
    newPayload.period = getPeriod(payload.period);
    if (!payload.isAllProjects) newPayload.projects = payload.projects;

    let res = await axios.post('/api/dashboards/widgets/transfer/report', newPayload)
      .then(res => res.data)
      .catch(error => {
        console.error(error);
      })

    return res
  },

  async loadExtendedOutgoingStatistic(context, payload) {
    let newPayload = {};
    newPayload.period = getPeriod(payload.period);
    if (!payload.isAllProjects) newPayload.projects = payload.projects;
    newPayload.type = payload.type;

    let res = await axios.post('/api/dashboards/widgets/extended-statistics-on-outgoing-calls/report', newPayload)
      .then(res => res.data)
      .catch(error => {
        console.warn(error);
        return false
      })

    return res
  },

  async loadOutgoingByOperators(context, payload) {
    let newPayload = {};
    newPayload.period = getPeriod(payload.period);
    if (!payload.isAllProjects) newPayload.projects = payload.projects;
    newPayload.type = payload.type;

    let res = {}

    try {
      res.table = await axios.post('/api/dashboards/widgets/outgoing-by-operators/report', newPayload)
        .then(res => res.data)
      res.bublik = await axios.post('/api/dashboards/widgets/statistics-on-outgoing-calls/report', newPayload)
        .then(res => res.data)

    } catch (error) {
      console.warn(error);
      
    }

    return res
  },

  async loadStatisticByQueues(context, payload) {
    let newPayload = {}
    newPayload.period = getPeriod(payload.period)
    if (!payload.isAllProjects) newPayload.projects = payload.projects

    try {
      return await axios.post('/api/dashboards/widgets/project-queues/report', newPayload)
        .then(res => res.data)
    } catch (error) {
      console.warn(error)
    }
  },

  async loadHourlyDynamicsWidget(context, payload) {
    let newPayload = {};
    newPayload.period = getPeriod(payload.period);
    if (!payload.isAllProjects) newPayload.projects = payload.projects;

    let res = await axios.post('/api/dashboards/widgets/hourly_dynamics/report', newPayload)
      .then(res => res.data)
      .catch(error => {
        console.error(error);
      })

    return res
  },

  async loadOperatorCampaignStatiscticByDaysWidget(context, payload) {
    let newPayload = {}
    newPayload.period = getPeriod(payload.period)
    newPayload.users = payload.users

    let res = await axios.post('/api/dashboards/widgets/operator_campaign_statisctic_by_days/report', newPayload)
      .then(res => res.data)
      .catch(error => {
        console.error(error);
      })

    return res
  },

  async loadPercentageAcceptByCampaignWidget(context, payload) {
    let newPayload = {}
    newPayload.period = getPeriod(payload.period)
    if (!payload.isAllCampaigns) newPayload.campaigns = payload.campaigns

    let res = await axios.post('/api/dashboards/widgets/percentage_accept_by_campaign/report', newPayload)
      .then(res => res.data)
      .catch(error => {
        console.error(error);
      })

    return res
  },

  changeEditedWidgetId({ commit }, payload) {
    commit('SET_EDITEDWIDGETID', payload);
  },
}

const mutations = {
  SET_DASHBOARDS(state, data) {
    state.dashboards = data;
  },

  SET_DASHBOARD(state, data) {
    state.dashboard = data;
  },

  SET_EDITEDWIDGETID(state, data) {
    state.editedWidgetId = data;
  },
}

function getPeriod(periodName) {
  let period = [];
  let start = '00:00:00';
  let end = '23:59:59';

  if (periodName === 'today') {
    period.push(moment().format(`YYYY-MM-DD ${start}`));
    period.push(moment().format(`YYYY-MM-DD ${end}`));
  } else if (periodName === 'yesterday') {
    period.push(moment().subtract(1, 'day').format(`YYYY-MM-DD ${start}`));
    period.push(moment().subtract(1, 'day').format(`YYYY-MM-DD ${end}`));
  } else if (periodName === 'currWeek') {
    period.push(moment().isoWeekday(1).format(`YYYY-MM-DD ${start}`));
    period.push(moment().format(`YYYY-MM-DD ${end}`));
  } else if (periodName === 'prevWeek') {
    period.push(moment().subtract(1, 'week').isoWeekday(1).format(`YYYY-MM-DD ${start}`));
    period.push(moment().subtract(1, 'week').isoWeekday(7).format(`YYYY-MM-DD ${end}`));
  } else if (periodName === 'currMonth') {
    period.push(moment().startOf('month').format(`YYYY-MM-DD ${start}`));
    period.push(moment().format(`YYYY-MM-DD ${end}`));
  } else if (periodName === 'prevMonth') {
    period.push(moment().subtract(1, 'month').startOf('month').format(`YYYY-MM-DD ${start}`));
    period.push(moment().subtract(1, 'month').endOf('month').format(`YYYY-MM-DD ${end}`));
  }

  return period
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}